import React from 'react'
import useId from 'hooks/useId';
import Tr from 'translations/Translations';
import AddAdditionalPositionForm from './AddAdditionalPositionForm';
import DoubleButton from '../components/DoubleButton';
import Dialog from 'components/Dialog';
import {connect} from 'react-redux'

function AddAdditionalPosition(
    {
        onClose = () => {
        },
        formSubmit,
        onAdd,
        initValues,
        partId,
        elementList,
        showParts
    }) {
    const formId = useId();

    const handleClose = () => {
        onClose();
    }

    const handleSubmit = () => {
        formSubmit[formId]()
    }

    const handleAdd = (values) => {
        onAdd(values);
    }

    return (
        <Dialog
            title={initValues ? Tr('edit_position') : Tr('add_position')}
            open={true}
            maxWidth='md'
            onClose={handleClose}
            dialogActions={showParts ? <DoubleButton
                justify='flex-end'
                labelFirst={Tr('cancel')}
                labelSecond={initValues ? Tr('save') : Tr('add')}
                onClickFirst={handleClose}
                onClickSecond={handleSubmit}
            /> : undefined}
        >
            <AddAdditionalPositionForm
                initValues={initValues}
                onSubmit={handleAdd}
                id={formId}
                partId={partId}
                elementList={elementList}
            />

        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(AddAdditionalPosition);